// Used on ShoppingCartPageComponent for displaying different routing buttons
export enum EmptyCartOptions {
    BUY_PERIOD = 'BUY_PERIOD',
    BUY_PERIOD_OR_LOAD_MONEY = 'BUY_PERIOD_OR_LOAD_MONEY'
}

// Used on RelatedCardDetailPageComponent for displaying different travel card actions
export enum CardActionsFeature {
    ADD_MONEY = 'ADD_MONEY'
}

// Used on AccountDetailPageComponent for displaying different account actions
export enum CustomerActionsFeature {
    CHANGE_EMAIL = 'CHANGE_EMAIL'
}

// Used on CustomerAccountDetailComponent to determine if customer confirms account deletion via email or checkbox
export enum AccountDeleteConfirmationType {
    CONFIRM_WITH_EMAIL = 'CONFIRM_WITH_EMAIL',
    CONFIRM_WITH_TICKBOX = 'CONFIRM_WITH_TICKBOX'
}

// Used on AppComponent for displaying different themes styles
export enum ThemeFeature {
    VL = 'vl',
    VASTMANLAND = 'vastmanland',
    TARTU = 'tartu-city',
    TARTU_APP = 'tartu',
    PILET = 'pilet',
    GOTLAND = 'gotland',
    GOTLAND_V2 = 'gotland-v2',
    PANEVEZYS = 'panevezys',
    PEUTK = 'peutk',
    SORMLAND_V2 = 'sormland-v2',
    KOHTLAJARVE = 'kohtla-jarve',
    OREBRO = 'orebro',
    VARMLAND = 'varmland',
    TALLINN = 'tallinn'
}

// Used on FooterAppComponent for displaying and ordering menu items
export enum MenuItem {
    explore = 'explore',
    schedule = 'schedule',
    ticket = 'ticket',
    card = 'card',
    disturbances = 'disturbances',
    menu = 'menu'
}
